import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CreateUserModal from "./modal_add_data/CreateUserModal";
import * as app_consts from "../../../../../constants/react_app_consts";
import AddProductModal from "./modal_add_data/AddProductModal";
import AddProductTypeModal from "./modal_add_data/AddProductTypeModal";
import AddUnitMeasurementModal from "./modal_add_data/AddUnitMeasurementModal";
import AddUserPropertyModal from "./modal_add_data/AddUserPropertyModal";
import AddCompanyRepresentativeModal from "./modal_add_data/AddCompanyRepresentativeModal";
import AddCompRepRoleModal from "./modal_add_data/AddCompRepRoleModal";
import AddWarehouseStorage from "./modal_add_data/AddWarehouseStorage";
import AddWarehouseStorageType from "./modal_add_data/AddWarehouseStorageType";
import AddDeliveryNoteProductModal from "./modal_add_data/AddDeliveryNoteProductModal";
import AddEmployeeModal from "./modal_add_data/AddEmployeeModal";
import AddGoodsReceivedProductsModal from "./modal_add_data/AddGoodsReceivedProductsModal";
import AddLoadingOrderProduct from "./modal_add_data/AddLoadingOrderProduct";
import AddEmployeeToBranch from "./modal_add_data/AddEmployeeToBranch";
import AddGRNScheduleModal from "./modal_add_data/AddGRNScheduleModal";
import AddGRNModal from "./modal_add_data/AddGRNModal";
import AddGRNProductsModal from "./modal_add_data/AddGRNProductsModal";
import FinalizeGRN from "./modal_add_data/FinalizeGRN";
import ReceivedGoodsModal from "./modal_add_data/ReceivedGoodsModal";
import AddDirectDeliveryNote from "./modal_add_data/AddDirectDeliveryNote";
import AddProductsToDirectDeliveryNoteModal from "./modal_add_data/AddProductsToDirectDeliveryNoteModal";
import FinalizeDN from "./modal_add_data/FinalizeDN";
import AddLoadingOrderModal from "./modal_add_data/AddLoadingOrderModal";
import AddProductsToLoadingOrderModal from "./modal_add_data/AddProductsToLoadingOrderModal";
import AddDNModal from "./modal_add_data/AddDNModal";
import AddProductsToWarehouseDeliveryNoteModal from "./modal_add_data/AddProductsToWarehouseDeliveryNoteModal";

// CHANGE: import new DN schedule modal component
import AddDNScheduleModal from "./modal_add_data/AddDNScheduleModal";

const ModalAdd = ({
  openModal,
  setOpenModal,
  type,
  modalTitle,
  modalDescription,
  succFunc,
  size,
  accountId,
  openOtherModalFunc,
  fullscreen,
  page_data
}) => {
  const [modal, setModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    setModal(openModal);
  }, [openModal]);

  const toggleModal = () => {
    setOpenModal(!modal);
  };

  return (
    <Modal
      isOpen={modal}
      className="modal-dialog-centered"
      size={size ? size : "lg"}
      fullscreen={fullscreen}
    >
      <ModalHeader toggle={!modalLoading ? toggleModal : ""}>{modalTitle}</ModalHeader>
      <ModalBody>
        {modal ? (
          <>
        {
          // Users
          type === app_consts.USER_LIST_TYPE ? (
            <CreateUserModal successFunction={succFunc} setModalLoading={setModalLoading} />
          ) : // Products
          type === app_consts.PRODUCT_LIST ? (
            <AddProductModal successFunction={succFunc} openModal={modal} setModalLoading={setModalLoading} />
          ) : // Product Types
          type === app_consts.PRODUCT_TYPE_LIST ? (
            <AddProductTypeModal successFunction={succFunc} openModal={modal} setModalLoading={setModalLoading} />
          ) : // Unit Measurement
          type === app_consts.UNIT_MEASUREMENT_LIST ? (
            <AddUnitMeasurementModal successFunction={succFunc} openModal={modal} setModalLoading={setModalLoading} />
          ) : // User Property
          type === app_consts.ONBOARD_USER_PROPERTY ? (
            <AddUserPropertyModal
              accountId={accountId}
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
            />
          ) : // Company Representative
          type === app_consts.ONBOARD_COMPANY_REPRESENTATIVE ? (
            <AddCompanyRepresentativeModal
              accountId={accountId}
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
            />
          ) : // Company Representative Role
          type === app_consts.ONBOARD_COMPANY_REPRESENTATIVE_ROLE ? (
            <AddCompRepRoleModal
              accountId={accountId}
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
            />
          ) : // Add Warehouse Storage
          type === app_consts.ADD_WAREHOUSE_STORAGE ? (
            <AddWarehouseStorage
              accountId={accountId}
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
            />
          ) : // Add Warehouse Storage Type
          type === app_consts.ADD_WAREHOUSE_STORAGE_TYPE ? (
            <AddWarehouseStorageType
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
            />
          ) : // Delivery Note Product
          type === app_consts.ADD_PRODUCTS_TO_DELIVERY_NOTE_TICKET ? (
            <AddDeliveryNoteProductModal
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
              page_data={accountId}
            />
          ) : // Add Employee
          type === app_consts.ADD_EMPLOYEE ? (
            <AddEmployeeModal
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
              page_data={accountId}
            />
          ) : // Add Goods Received Product
          type === app_consts.ADD_PRODUCTS_TO_GOODS_RECEIVED_NOTE_TICKET ? (
            <AddGoodsReceivedProductsModal
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
              page_data={accountId}
            />
          ) : // Add Loading Order Product
          type === app_consts.ADD_LOADING_ORDER_PRODUCT_TABLE ? (
            <AddLoadingOrderProduct
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
              page_data={accountId}
            />
          ) : // Add GRN Schedule
          type === app_consts.GRN_SCHEDULER_LIST ? (
            <AddGRNScheduleModal successFunction={succFunc} setModalLoading={setModalLoading} />
          ) : // CHANGE: Add DN Schedule
          type === app_consts.DN_SCHEDULER_LIST ? (
            <AddDNScheduleModal successFunction={succFunc} setModalLoading={setModalLoading} />
          ) : // Add GRN
          type === app_consts.GOODS_RECEIVED_WEIGH_BRIDGE_TICKET_LIST ? (
            <AddGRNModal successFunction={succFunc} setModalLoading={setModalLoading} openModal={modal} />
          ) : // Add Loading Order
          type === app_consts.LOADING_ORDERS_LIST ? (
            <AddLoadingOrderModal successFunction={succFunc} setModalLoading={setModalLoading} openModal={modal} />
          ) : // Add Products to GRN
          type === app_consts.ADD_PRODUCTS_TO_GRN ? (
            <AddGRNProductsModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Add Products to Loading Order
          type === app_consts.ADD_PRODUCTS_TO_LOADING_ORDER ? (
            <AddProductsToLoadingOrderModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Receive Goods
          type === app_consts.RECVEIVE_GOODS ? (
            <ReceivedGoodsModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Create Direct Delivery Note
          type === app_consts.CREATE_DIRECT_DELIVERY_NOTE ? (
            <AddDirectDeliveryNote openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Add Products to Direct Delivery
          type === app_consts.ADD_PRODUCTS_TO_DIRECT_DELIVERY ? (
            <AddProductsToDirectDeliveryNoteModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Add Products to Warehouse Delivery Note
          type === app_consts.ADD_PRODUCTS_TO_WAREHOUSE_DELIVERY ? (
            <AddProductsToWarehouseDeliveryNoteModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Add DN Modal
          type === app_consts.DELIVERY_NOTES_WEIGH_BRIDGE_TICKET_LIST ? (
            <AddDNModal openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Finalize GRN
          type === app_consts.FINALIZE_GRN ? (
            <FinalizeGRN openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Finalize DN
          type === app_consts.FINALIZE_DN ? (
            <FinalizeDN openModal={modal} successFunction={succFunc} setModalLoading={setModalLoading} page_data={page_data} />
          ) : // Add Employee to Branch
          type === app_consts.ADD_EMPLOYEE_TO_BRANCH ? (
            <AddEmployeeToBranch
              successFunction={succFunc}
              openModal={modal}
              setModalLoading={setModalLoading}
              openOtherModalFunc={openOtherModalFunc}
              page_data={accountId}
            />
          ) : (
            ""
          )
        }
          </>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default ModalAdd;
